import script from "./StoryCommentCreated.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentCreated.vue?vue&type=script&lang=js"
export * from "./StoryCommentCreated.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentCreated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/story-comment/StoryCommentCreated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c621d06e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c621d06e', __exports__)) {
    api.reload('c621d06e', __exports__)
  }
  
}


export default __exports__